var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.254,
    height: 41.258,
    viewBox: "0 0 41.254 41.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3854",
    "data-name": "Rectangle 3854",
    width: 41.254,
    height: 41.258,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9322",
    "data-name": "Group 9322",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9306",
    "data-name": "Group 9306",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44113",
    "data-name": "Path 44113",
    d: "M20.639,0A20.629,20.629,0,1,1,0,20.616,20.627,20.627,0,0,1,20.639,0M2.9,20.634A17.727,17.727,0,1,0,20.63,2.9,17.71,17.71,0,0,0,2.9,20.634",
    transform: "translate(0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44114",
    "data-name": "Path 44114",
    d: "M159.731,150.939q0-2.81,0-5.62a1.441,1.441,0,1,1,2.873-.006q0,5.642,0,11.285a1.442,1.442,0,1,1-2.873.006q0-2.833,0-5.665",
    transform: "translate(-140.542 -126.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44115",
    "data-name": "Path 44115",
    d: "M157.638,95.587a1.9,1.9,0,0,1-1.914-1.9,1.919,1.919,0,1,1,3.838-.037,1.907,1.907,0,0,1-1.924,1.936",
    transform: "translate(-137.015 -80.716)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.a94355dba589c22a1bfd8bc806326dbb.svg";
export { ForwardRef as ReactComponent };